/**
 * The one seam between the SPA and real browser navigation. jsdom's `Location`
 * is [LegacyUnforgeable] — `vi.spyOn(window.location, "assign")` cannot work —
 * so callers route through these one-liners and suites mock the module instead.
 */

/** Full-document navigation (`window.location.assign`). */
export function navigateTo(path: string): void {
  window.location.assign(path);
}

/** Full-document reload — re-runs the bundle and clears all state. */
export function reloadPage(): void {
  window.location.reload();
}
